import cappuccino from '../Images/cappuccino.jpg';
import sandwich from '../Images/Sandwich.jpg';
import juice from '../Images/juice.jpg';


const products=[
    {
        image:cappuccino,
        item:"Cappuccino",
        price:"$3",
        description:"A classic Italian delight, our Cappuccino features a perfect balance of rich, bold espresso topped with creamy, velvety milk foam."

    },
    {
        image:sandwich,
        item:"Sandwich",
        price:"$8",
        description:"Enjoy our fresh, flavorful sandwiches made with quality ingredients for the perfect meal anytime."

    },
    {
        image:juice,
        item:"Fresh Juice",
        price:"$8",
        description:"Savor our refreshing, freshly squeezed juices, packed with natural flavors to energize your day."

    },
]

export default products; 